import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import { Styled } from 'app/features/newLanding/components/HeroBlock/Perks/Perk.styled';

const AdFreeAnime = () => (
  <Styled.Perk data-t="add-free-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="orange">
      <path d="M20 40c-3.303 0-6-2.687-6-6 0-3.303 2.687-6 6-6 3.303 0 6 2.687 6 6a6 6 0 01-6 6zm0-2a4 4 0 004-4c0-2.205-1.797-4-4-4-2.205 0-4 1.797-4 4 0 2.205 1.797 4 4 4zm0-38a6 6 0 016 6v14a6 6 0 11-12 0V6a6 6 0 016-6zm0 2a4 4 0 00-4 4v14a4 4 0 108 0V6a4 4 0 00-4-4z" />
    </Styled.PerkIcon>
    <Heading as={Styled.PerkDescription} size="xxs">
      <FormattedMessage id="new_landing_ad_free_perk" />
    </Heading>
    <Text
      as={Styled.PerkDescriptionMobile}
      size="xl"
      type="semibold"
      isFixedSize
    >
      <FormattedMessage id="new_landing_ad_free_perk" />
    </Text>
  </Styled.Perk>
);

export default AdFreeAnime;
